<template>
  <v-card flat class="pa-4">
    <!-- Snackbar -->
    <v-snackbar v-model="mensaje.snackbar" :timeout="mensaje.timeout" :color="mensaje.color" text top right>
      {{ mensaje.text }}
      <template v-slot:action="{ attrs }">
        <v-btn :color="mensaje.colorBtn" text v-bind="attrs" @click="mensaje.snackbar = false">Cerrar</v-btn>
      </template>
    </v-snackbar>

    <!-- Botón nueva categoría -->
    <v-row class="mb-3">
      <v-col>
        <v-btn color="deep-purple" dark @click="openDialog(null)">
          <v-icon left>mdi-plus</v-icon> Nueva Categoría
        </v-btn>
      </v-col>
    </v-row>

    <!-- Tabla de categorías -->
    <v-simple-table fixed-header>
      <template v-slot:default>
        <thead>
          <tr>
            <th>Id</th>
            <th>Nombre</th>
            <th>Slug</th>
            <th>Color</th>
            <th>Icono</th>
            <th>Eventos</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="cat in categorias" :key="cat.id">
            <td>{{ cat.id }}</td>
            <td>{{ cat.name }}</td>
            <td class="grey--text">{{ cat.slug }}</td>
            <td>
              <v-avatar size="20" :color="cat.color || '#E0E0E0'"></v-avatar>
            </td>
            <td><v-icon v-if="cat.icon" small>{{ cat.icon }}</v-icon></td>
            <td>{{ cat.events_count || 0 }}</td>
            <td>
              <v-btn icon color="primary" small @click="openDialog(cat)">
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon color="red" small @click="eliminar(cat)">
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </td>
          </tr>
          <tr v-if="categorias.length === 0">
            <td colspan="7" class="text-center grey--text pa-4">No hay categorías registradas.</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <!-- Dialog crear/editar categoría -->
    <v-dialog v-model="dialog" max-width="500" persistent>
      <v-card>
        <v-card-title class="deep-purple darken-1 white--text">
          {{ editando ? 'Editar' : 'Nueva' }} Categoría
        </v-card-title>
        <v-card-text class="pt-4">
          <v-form ref="formCat" v-model="validCat">
            <v-text-field v-model="catForm.name" label="Nombre *" :rules="[v => !!v || 'Requerido']"
              required outlined dense></v-text-field>

            <v-text-field v-model="catForm.icon" label="Icono (ej: mdi-laptop)"
              hint="Clases de Material Design Icons" outlined dense>
              <template v-slot:prepend-inner>
                <v-icon small>{{ catForm.icon || 'mdi-help' }}</v-icon>
              </template>
            </v-text-field>

            <v-row align="center">
              <v-col cols="8">
                <v-text-field v-model="catForm.color" label="Color temático"
                  hint="Código hexadecimal" persistent-hint outlined dense></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-menu :close-on-content-click="false" offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn outlined small v-bind="attrs" v-on="on">
                      <v-avatar size="20" :color="catForm.color || '#E0E0E0'" class="mr-1"></v-avatar>
                      Elegir
                    </v-btn>
                  </template>
                  <v-color-picker v-model="catForm.color" hide-inputs show-swatches
                    :swatches="colorSwatches" mode="hexa"></v-color-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">Cancelar</v-btn>
          <v-btn color="deep-purple" dark @click="guardarCategoria">
            {{ editando ? 'Actualizar' : 'Guardar' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import eventService from '@/services/eventService.js';

export default {
  name: 'EventCategoryAdmin',
  data() {
    return {
      categorias: [],
      dialog: false,
      editando: false,
      validCat: true,
      catForm: {
        id: null,
        name: '',
        icon: '',
        color: ''
      },
      colorSwatches: [
        ['#E3F2FD', '#BBDEFB', '#90CAF9'],
        ['#E8F5E9', '#C8E6C9', '#A5D6A7'],
        ['#FFF3E0', '#FFE0B2', '#FFCC80'],
        ['#F3E5F5', '#E1BEE7', '#CE93D8'],
        ['#ECEFF1', '#CFD8DC', '#B0BEC5'],
        ['#FFEBEE', '#FFCDD2', '#EF9A9A']
      ],
      mensaje: {
        snackbar: false,
        text: '',
        color: '',
        colorBtn: '',
        timeout: 4000
      }
    };
  },
  mounted() {
    this.listarCategorias();
  },
  methods: {
    listarCategorias() {
      eventService.listarCategorias().then(res => {
        this.categorias = res.data;
      }).catch(() => {
        this.showMsg('Error al cargar categorías', 'error');
      });
    },
    openDialog(cat) {
      if (cat) {
        this.editando = true;
        this.catForm = {
          id: cat.id,
          name: cat.name,
          icon: cat.icon || '',
          color: cat.color || ''
        };
      } else {
        this.editando = false;
        this.catForm = { id: null, name: '', icon: '', color: '' };
      }
      this.dialog = true;
    },
    guardarCategoria() {
      if (!this.$refs.formCat.validate()) return;

      // Normalizar color: recortar a 7 caracteres (#RRGGBB)
      if (this.catForm.color && this.catForm.color.length > 7) {
        this.catForm.color = this.catForm.color.substring(0, 7);
      }

      const action = this.editando
        ? eventService.updateCategoria(this.catForm.id, this.catForm)
        : eventService.saveCategoria(this.catForm);

      action.then(() => {
        this.showMsg(this.editando ? 'Categoría actualizada' : 'Categoría creada', 'success');
        this.dialog = false;
        this.listarCategorias();
      }).catch(err => {
        const msg = err.response && err.response.data && err.response.data.message;
        this.showMsg(msg || 'Error al guardar', 'error');
      });
    },
    eliminar(cat) {
      if (!confirm('¿Eliminar la categoría "' + cat.name + '"?')) return;
      eventService.deleteCategoria(cat.id).then(() => {
        this.showMsg('Categoría eliminada', 'success');
        this.listarCategorias();
      }).catch(() => {
        this.showMsg('Error al eliminar', 'error');
      });
    },
    showMsg(text, type) {
      this.mensaje.text = text;
      this.mensaje.color = type === 'success' ? 'success' : 'error';
      this.mensaje.colorBtn = type === 'success' ? 'green darken-1' : 'red darken-1';
      this.mensaje.snackbar = true;
    }
  }
};
</script>
